module.exports = __webpack_public_path__ + "static/media/hyundai-off-app-provider-icon.7d8ebfbf.svg";